<template>

    <component :is="layoutComponent"></component>

</template>

<script>
import AppLayout from './app-layout.vue'
import GuestLayout from './guest-layout.vue'

export default {

    computed: {
        layoutComponent () {
            return this.$route.meta.layout === 'guest' ? GuestLayout : AppLayout
        }
    }

}
</script>
